import { Directive } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  // eslint-disable-next-line
  selector: 'input[type=file]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '(change)': 'onChange($event.target.files)',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '(blur)': 'onTouched()'
  },
  providers: [ { provide: NG_VALUE_ACCESSOR, useExisting: FileValueAccessor, multi: true } ]
})
// https://github.com/angular/angular/issues/7341
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class FileValueAccessor implements ControlValueAccessor {
  value: any;
  onChange = (_): void => {
  };
  onTouched = (): void => {
  };

  writeValue(value): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
